import { ChevronDown, Megaphone, Target, Telescope } from 'lucide-react';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/ui/design-system/components/ui/dropdown-menu';
import { USE_CASE_GROUPS } from './suggestions';
import { cn } from '@/ui/design-system/utils/cn';

// Outline (stroke-only) icons per theme — more legible than the emoji glyphs,
// which rendered low-contrast (e.g. the white telescope). Keyed by group id so
// `suggestions.js` stays pure data.
const GROUP_ICON = {
    discovery: Telescope,
    marketing: Megaphone,
    strategy: Target,
};

// Pill styling mirrors the existing home-command-center suggestion pills so the
// two surfaces stay visually identical. `data-[state=open]` keeps the trigger
// highlighted while its menu is open.
const PILL_CLASSES =
    'inline-flex min-w-0 max-w-full items-center gap-2 rounded-full border border-base-card bg-background px-[10px] py-[6px] text-sm text-foreground transition-colors hover:border-[#8757ff] hover:bg-[#f6f1ff] hover:text-[#5e2bcf] data-[state=open]:border-[#8757ff] data-[state=open]:bg-[#f6f1ff] data-[state=open]:text-[#5e2bcf]';

// Three themed dropdown pills (Discovery / Marketing / Strategy). Selecting a
// menu item calls `onSelect(item)` with `{ label, prompt }`; the caller decides
// what to do with it (both surfaces fill their composer input).
const UseCasePills = ({ onSelect, className }) => (
    <div className={cn('flex flex-wrap gap-[10px]', className)}>
        {USE_CASE_GROUPS.map((group) => {
            const GroupIcon = GROUP_ICON[group.id];
            return (
                <DropdownMenu key={group.id}>
                    <DropdownMenuTrigger asChild>
                        <button type="button" className={PILL_CLASSES}>
                            <span className="inline-flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full bg-muted">
                                <GroupIcon size={14} />
                            </span>
                            <span className="truncate">{group.label}</span>
                            <ChevronDown
                                size={14}
                                className="shrink-0 opacity-60"
                            />
                        </button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                        align="start"
                        className="max-w-[400px]"
                        onCloseAutoFocus={(e) => e.preventDefault()}
                    >
                        {group.items.map((item) => (
                            <DropdownMenuItem
                                key={item.label}
                                onSelect={() => onSelect(item)}
                            >
                                {item.label}
                            </DropdownMenuItem>
                        ))}
                    </DropdownMenuContent>
                </DropdownMenu>
            );
        })}
    </div>
);

export default UseCasePills;
